import { I18n } from "@/i18n/I18n";
import { Placeholder } from "react-bootstrap";

export function TwoPanelPlaceholder() {
  return (
    <div className="d-flex flex-column" aria-label={I18n.get('loading')}>
      <div style={{borderBottom: '1px solid #E6E4E2', background: '#F8F8F8'}} className="breadcrumb-bar p-3 d-flex align-items-center gap-2">
        <Placeholder animation="wave" className="my-auto">
          <Placeholder xs={4} size="sm" bg="secondary" />
        </Placeholder>
      </div>
      <div className="d-flex flex-grow-1">
        <div
          className="d-flex flex-column p-4"
          style={{
            width: '320px',
            minWidth: '320px',
            minHeight: '100vh',
            backgroundColor: 'var(--neutral-100)',
            borderRight: '1px solid #dee2e6',
          }}
        >
          <Placeholder animation="wave" className="mb-1">
            <Placeholder xs={10} size="lg" bg="dark" />
          </Placeholder>
          <Placeholder animation="wave" className="mb-4">
            <Placeholder xs={12} size="sm" bg="secondary" />
            <Placeholder xs={8} size="sm" bg="secondary" />
          </Placeholder>

          <Placeholder animation="wave" className="mb-2">
            <Placeholder xs={5} size="xs" bg="secondary" />
          </Placeholder>
          {[9, 7, 6, 8, 7, 6, 5].map((width, i) => (
            <Placeholder key={i} animation="wave" className="py-2">
              <Placeholder xs={width} bg="secondary" />
            </Placeholder>
          ))}

          <Placeholder animation="wave" className="mt-4 mb-2">
            <Placeholder xs={3} size="xs" bg="secondary" />
          </Placeholder>
          {[4, 5, 4].map((width, i) => (
            <Placeholder key={i} animation="wave" className="py-2">
              <Placeholder xs={width} bg="secondary" />
            </Placeholder>
          ))}
        </div>

        <div className="flex-grow-1 p-3">
          <Placeholder animation="wave" className="mb-3">
            <Placeholder xs={3} size="lg" bg="secondary" style={{ borderRadius: '99px' }} />
          </Placeholder>
          <div className="border rounded" style={{ borderColor: 'var(--neutral-200)' }}>
            <div className="d-flex border-bottom p-2">
              <Placeholder animation="wave" className="w-50"><Placeholder xs={4} size="sm" bg="secondary" /></Placeholder>
              <Placeholder animation="wave" style={{ width: '88px' }}><Placeholder xs={8} size="sm" bg="secondary" /></Placeholder>
              <Placeholder animation="wave" style={{ width: '96px' }}><Placeholder xs={8} size="sm" bg="secondary" /></Placeholder>
              <Placeholder animation="wave" style={{ width: '131px' }}><Placeholder xs={10} size="sm" bg="secondary" /></Placeholder>
            </div>
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="d-flex border-bottom p-2">
                <Placeholder animation="wave" className="w-50">
                  <Placeholder xs={7} bg="secondary" />
                  <Placeholder xs={5} size="sm" bg="secondary" />
                </Placeholder>
                <Placeholder animation="wave" style={{ width: '88px' }}><Placeholder xs={10} size="sm" bg="secondary" /></Placeholder>
                <Placeholder animation="wave" style={{ width: '96px' }}><Placeholder xs={8} size="sm" bg="secondary" /></Placeholder>
                <Placeholder animation="wave" style={{ width: '131px' }}><Placeholder xs={6} size="sm" bg="secondary" /></Placeholder>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
